import axios from '@/jslib/axios'

export const getAquaLandList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/aqualand/list',
    params,
    ...other
  })
}

